const PaperPlaneIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <clipPath id="7qnzfvruaa">
          <path
            data-name="사각형 32246"
            fill="#fff"
            d="M0 0h21.332v21.336H0z"
          />
        </clipPath>
      </defs>
      <g data-name="ic / 24 / share / white">
        <path data-name="사각형 32245" fill="none" d="M0 0h24v24H0z" />
        <g data-name="그룹 45159">
          <g
            data-name="그룹 45158"
            style={{ clipPath: 'url(#7qnzfvruaa)' }}
            transform="translate(1.334 2.332)"
          >
            <path
              data-name="패스 16465"
              d="M8.711 13.662a1.465 1.465 0 0 0 .21-.15q2.157-2.152 4.311-4.307a.816.816 0 0 0 .279-.849.769.769 0 0 0-1.211-.407 2.052 2.052 0 0 0-.213.2q-2.146 2.146-4.288 4.3a.272.272 0 0 1-.388.057Q4.172 10.772.923 9.06a1.522 1.522 0 0 1-.914-1.57 1.543 1.543 0 0 1 1.185-1.377Q7.859 3.9 14.518 1.671L19.2.107a1.518 1.518 0 0 1 1.678.361 1.522 1.522 0 0 1 .343 1.661L15.2 20.223a1.559 1.559 0 0 1-2.89.245q-1.761-3.31-3.51-6.623c-.022-.042-.041-.085-.089-.183"
              style={{ fill: '#fff' }}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PaperPlaneIcon
